import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    subtitleMessage() {
      return this.hasError ? this.errorMessage : this.subtitle;
    },
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    hasError() {
      return this.validationState === VALIDATION_STATES.error;
    },
    showLoading() {
      return this.isLoading && !!this.$slots.loading;
    },
  },
  data() {
    return {
      correction: '',
      offset: 0,
    };
  },
  mounted() {
    // cache
    // this.$header = this.$refs.header;
    // this.$content = this.$refs.content;

    // // calculation
    // this.magicVerticalCentering();

    // window.addEventListener('resize', this.magicVerticalCentering);
    // window.addEventListener('stepChange', this.magicVerticalCentering);
  },

  beforeDestroy() {
    // window.removeEventListener('resize', this.magicVerticalCentering);
    // window.removeEventListener('stepChange', this.magicVerticalCentering);
  },

  methods: {
    magicVerticalCentering() {
      // reset correction so we can perform calculations again
      this.correction = '';
      const pageH = document.body.offsetHeight;
      const contentOffset = document.body.scrollHeight - pageH;
      let rule;

      if (contentOffset > 0) {
        // content longer than page: not centered, just beneath the title
        this.correction = '';
      } else {
        // current content top
        const contentH = this.$content.offsetHeight;
        // apparently, even knowing correction styles were reset
        // content.offsetTop was calculated with previous step offset
        // solution is to cache offset and substract from top calculation
        const contentTop = this.$content.offsetTop - this.offset;
        // max content top to allow the distante from title
        const headerH = pageH - this.$el.offsetHeight;
        const computed = window.getComputedStyle(this.$el);
        const stepTopPadding = parseInt(computed.getPropertyValue('padding-top'), 10);
        const titleH = (this.$header) ? this.$header.offsetHeight : 0;
        const maxExpectedContentTop = headerH + stepTopPadding + titleH;
        // correction
        const centeredExpectedContentTop = (pageH - contentH) / 2;
        this.offset = centeredExpectedContentTop - contentTop;
        if (this.offset < 0 && (this.offset < maxExpectedContentTop - contentTop)) {
          // must go up but keeping the maxExpectedContentTop
          this.offset = maxExpectedContentTop - contentTop;
        }
        // apply correction
        if (this.offset < 0) {
          // negative offset can use top
          rule = `top: ${this.offset}px`;
        } else if (this.offset > 0) {
          // use margin-top to keep actions at its distance
          rule = `margin-top: ${this.offset}px`;
        }

        this.correction = `${rule}`;
      }
    },
  },
};
